import { create } from "zustand";

const HostelStore = create((set) => ({
  hostelId: "",
  action: "" /*======>1-view/2-edit/3-delete/0-mean no action======>*/,
  setHostelId: (_id) => {
    set((prev) => ({ ...prev, hostelId: _id }));
  },
  setAction: (_actionId) => {
    set((prev) => ({
      ...prev,
      action:
        _actionId === 1
          ? "view"
          : _actionId === 2
          ? "edit"
          : _actionId === 3
          ? "delete"
          : "",
    }));
  },
}));
export default HostelStore;
